import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Divider,
  Button
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const FaqPage = () => {
  // FAQ data
  const faqs = [
    {
      question: 'What is Laprecio?',
      answer: 'Laprecio is a secure, transparent, and efficient platform for trading minerals globally with full compliance and traceability. Our platform connects miners, processors, manufacturers, traders, and regulators in a single ecosystem.'
    },
    {
      question: 'How do I register for Laprecio?',
      answer: 'You can register for Laprecio by clicking the "Register Now" button on our homepage or by visiting the registration page directly. You\'ll need to provide some basic information about yourself and your company, and agree to our terms of service.'
    },
    {
      question: 'Is Laprecio secure?',
      answer: 'Yes, Laprecio employs state-of-the-art security measures including end-to-end encryption, multi-factor authentication, and blockchain verification to ensure the security of all transactions and data on our platform.'
    },
    {
      question: 'What types of minerals can be traded on Laprecio?',
      answer: 'Laprecio supports trading of a wide range of minerals including precious metals, base metals, industrial minerals, and rare earth elements. Our platform is designed to accommodate the specific requirements of different mineral types.'
    },
    {
      question: 'How does Laprecio ensure compliance with regulations?',
      answer: 'Laprecio has built-in compliance tools that automatically check transactions against international regulations such as the EU Conflict Minerals Regulation, OECD Due Diligence Guidance, and the US Dodd-Frank Act. Our platform also generates comprehensive reports for regulatory submissions.'
    },
    {
      question: 'What fees does Laprecio charge?',
      answer: 'Laprecio charges a small transaction fee for each successful trade on our platform. We also offer premium subscription plans with additional features and reduced fees. Please contact us for detailed pricing information.'
    },
    {
      question: 'How does Laprecio verify the origin of minerals?',
      answer: 'Laprecio uses a combination of documentation verification, third-party certifications, and blockchain technology to verify and track the origin of minerals. This ensures complete transparency and traceability throughout the supply chain.'
    },
    {
      question: 'Can I integrate Laprecio with my existing systems?',
      answer: 'Yes, Laprecio offers API integration with various ERP, CRM, and supply chain management systems. Our team can work with you to ensure seamless integration with your existing infrastructure.'
    },
    {
      question: 'Is Laprecio available worldwide?',
      answer: 'Yes, Laprecio is a global platform available to users worldwide. We support multiple languages and currencies to facilitate international trade.'
    },
    {
      question: 'How can I get support if I have issues with Laprecio?',
      answer: 'You can contact our support team at hello@laprecio.com. We also offer comprehensive documentation and tutorials to help you get the most out of our platform.'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" component="h1" align="center" gutterBottom>
        Frequently Asked Questions
      </Typography>
      
      <Box sx={{ mt: 4 }}>
        {faqs.map((faq, index) => (
          <Accordion key={index} sx={{ mb: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography variant="h6">{faq.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      
      <Divider sx={{ my: 6 }} />
      
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Still have questions?
        </Typography>
        <Typography variant="body1" paragraph>
          If you couldn't find the answer to your question, please don't hesitate to contact us.
        </Typography>
        <Button
          component={RouterLink}
          to="/contact"
          variant="contained"
          color="primary"
          size="large"
          sx={{ mt: 2 }}
        >
          Contact Us
        </Button>
      </Box>
    </Container>
  );
};

export default FaqPage;
